<script>
// @ts-check

export default {
  data: function() {
    return {}
  },
}
</script>

<template>
  <v-card style="min-width:320px">
    <v-card-text>
      <b>DAP/Recommended Plan</b> - The percentage of graduates who satisfied the course requirements for the Recommended High School Program, Distinguished Achievement Program, or at the Foundation High School Program with an endorsement or the distinguished level of achievement. Year 2016-2017 is DAP/RHSP data only.
    </v-card-text>
  </v-card>
</template>
